import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, Modal } from '@mui/material';

import api from '@/services/api';

import Spinner from '@/views/components/Spinner/Spinner';

const style = {
	maxWidth: '660px !important',
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	background: '#FFFFFF',
	boxShadow: '0px 3px 6px #00000029',
	borderRadius: '6px',
};

const ModalDeleteItem = ({ itemToDelete, setItemToDelete, reloadDictionary }) => {
	//// IF editValues isn't null - switch do edit Mode
	const { dict } = useSelector((state) => state.app);
	const [ loading, setLoading ] = useState(false);

	const handleClose = useCallback(() => {
		setLoading(false);
		reloadDictionary();
		setItemToDelete(null);
	}, []);

	const removeConfirmed = () => {
		setLoading(true);
		api.delete(`/dict-entries/${itemToDelete.id}`)
			.then(() => {
				handleClose();
			}).catch(({ response }) => {
				handleClose();
			});
	};

	return (
		<Modal
			open
			onClose={ handleClose }
			aria-labelledby='modal-modal-title'
			aria-describedby='modal-modal-description'
		>
			<Box
				sx={ style }
			>
				{
					loading && (
						<Spinner
							addClass='dictionary__spinner'
						/>
					)
				}

				<h1>{dict.dictionary.modal.deleteElement}</h1>
				<hr />
				<div className='form__header-text'>
					{/* .replace('??', ) */}
					{dict.dictionary.modal.deleteComment.replace('??', `"${itemToDelete.inputPhrase}"`)}
				</div>
				<section className='form__buttons'>
					<Button
						color='primary'
						variant='contained'
						className='button__transparent'
						sx={ { textTransform: 'none' } }
						onClick={ () => handleClose() }
					>
						{dict.cancel}
					</Button>
					<Button
						color='primary'
						variant='contained'
						fullWidth
						className='button__blue'
						onClick={ () => removeConfirmed() }
						sx={ { textTransform: 'none' } }
					>
						{dict.delete}
					</Button>
				</section>

			</Box>
		</Modal>
	);
};

export default React.memo(ModalDeleteItem);